import { useMemo } from 'react'

import { User } from '../../../models/User'

import { useInitializeDocumentFilters, useInitializeDocumentTypes } from './hooks'

interface MeetingPrepDocumentsInitializationProps {
  clients: User[]
}

export const MeetingPrepDocumentsInitialization: React.FC<MeetingPrepDocumentsInitializationProps> = ({ clients }) => {
  const contactIds = useMemo(() => clients.map((client) => client.id), [clients])

  useInitializeDocumentTypes()
  useInitializeDocumentFilters(contactIds)

  return null
}
